<template>
  <img v-if="!isDesktop" :src="getAssetImage('twinkle.svg')" alt="Ask AI" class="ai-icon-condensed" />
  <span v-else class="ask-ai-btn-inner">
    <span>Ask Macy's</span>
    <img :src="getAssetImage('starIcon.svg')" alt="Ask AI" class="star-icon" />
  </span>
</template>
<script setup>
import { computed } from 'vue';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import getAssetImage from '~/utils/getAssetImage';

const navViewType = useNavViewType();
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);
</script>

<style scoped lang="scss">
.ai-icon-condensed {
  display: block;
  width: 28px;
  height: 28px;
}

.ask-ai-btn-inner {
  background: #fff;
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  z-index: 2;
  .star-icon {
    width: 15px;
    height: 15px;
    color: #000;
    margin-bottom: 5px;
    margin-left: -4px;
  }
}
</style>
